<template>
  <generic-preview :record="record" :hide-options="hideOptions" @edit="edit" @remove="remove">
    <preview-wrapper :record="record" :hide-options="hideOptions">
      <div class="grid grid-cols-2 gap-4">
        <!-- <div class="col-span-2">
          <span class="text-sm font-medium">Pain Assessment:
            <span class="text-sm text-neutral-500">
              {{record.painAssessmentScale}}
            </span>
          </span>
        </div> -->
        <template v-for="(field, index) in formFields" :key="index">
          <div v-if="record[field.field]" class="flex flex-col gap-2">
            <span class="text-sm font-medium">{{field.label}}</span>
            <span class="text-sm text-neutral-500">{{formatStatusCasing(record[field.field]?.status)}}</span>
            <span v-if="record[field.field]?.status === 'positive'" class="text-sm text-neutral-500">{{record[field.field]?.text}}</span>
          </div>
        </template>
      </div>
    </preview-wrapper>
  </generic-preview>
</template>

<script>
import { computed } from 'vue';
import { format } from 'date-fns';
import { FORM_FIELDS } from './constants';
import { usePhysicalExam } from './composables';
import GenericPreview from '@/components/medical-records/generic-preview.vue';
import PreviewWrapper from '@/components/medical-records/preview-wrapper.vue';

export default {
  components: {
    GenericPreview,
    PreviewWrapper,
  },
  props: {
    record: {
      type: Object,
      defafault: () => ({}),
    },
    hideOptions: {
      type: Boolean,
      default: false,
    },
    showRecordLabel: {
      type: Boolean,
      default: false,
    },
  },
  setup (props, { emit }) {
    const { remove: removePe } = usePhysicalExam();
    const text = computed(() => props.record.text);
    const createdAt = computed(() => format(new Date(props.record.createdAt), 'MM/dd/yyyy hh:mm a'));

    function edit () {
      emit('edit', props.record);
    }

    function remove () {
      removePe({ id: props.record.id });
    }

    function formatStatusCasing (str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }

    return {
      createdAt,
      text,
      formFields: FORM_FIELDS,
      edit,
      remove,
      formatStatusCasing,
    };
  },
};
</script>
